var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 837,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 838,
	"./assets/thewest-digital-hero-variation-a.jpg": 2890,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 839,
	"./assets/thewest-digital-hero-variation-b.jpg": 2891,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 840,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2892,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 841,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2893,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 842,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2894,
	"./assets/thewest-digital-hero.jpg": 2895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2889;